const id = parseInt( location.search.replace(/(.*)article=([\d]+?)(.*)?$/,'$2')|| 1 )
const add_body_class = cname => document.body.classList.add(cname)

export default function CASE() {

  const post_switch = () => {
    switch(id){
      case 2: add_body_class('is--case-shop'); break
      case 3: add_body_class('is--case-facility'); break
      case 1: default: add_body_class('is--case-house'); break
    }
  }
  document.addEventListener('DOMContentLoaded',post_switch)
}